<template>
  <div class="register absolute" style="background:#fff;">
    <van-nav-bar
      :title="$t('m.dl_span5')"
      @click-left="onClickLeft"
      left-arrow
    ></van-nav-bar>
    <div class="shading" style="padding:0 40px;">
      <div
        class="pictrue acea-row row-center-wrapper"
        style="height: 0.8rem;"
      ></div>
      <div class="biaoti">
        <div style="display:flex;align-items:center;">
          <img
            src="../../assets/images/img/img/logo.png"
            style="border-radius:15px;"
            alt=""
          />
        </div>
        {{ $t("m.dl_span05") }}
      </div>
    </div>
    <div class="register_block">
      <div class="register_block_list">
        <country-code-selector
          style="background-color:#fff;"
          :countryCode.sync="value"
        ></country-code-selector>
        <input
          v-model="account"
          :placeholder="$t('m.dl_span2')"
          style="padding-left:10px;"
        />
      </div>
      <div class="register_block_list">
        <input v-model="password" :placeholder="$t('m.dl_span3')" />
      </div>
      <div class="register_block_list">
        <input v-model="password2" :placeholder="$t('m.dl_span18')" />
      </div>
      <van-button class="register_submit" @click="registerReset">{{
        $t("m.tijiao")
      }}</van-button>
    </div>

    <div
      v-if="show"
      style="background: rgba(0, 0, 0, 0.5);position: fixed;width: 100%;height: 100%;left:0;top:0;display: flex;align-items: center;justify-content: center;"
    >
      <div
        style="background: rgba(0, 0, 0, 0.7);width:130px;height:130px;border-radius:8px;text-align:center;line-height:130px;color:#fff;font-size:16px;"
      >
        {{ $t("m.tijiaoing") }}
      </div>
    </div>
  </div>
</template>

<script>
import { registerReset } from "@api/user";
import { validatorDefaultCatch } from "@utils/dialog";
import { required, alpha_num } from "@utils/validate";
import countryCodeSelector from "@components/CodeSelector/components/index";
export default {
  components: {
    countryCodeSelector
  },
  name: "RetrievePassword",
  data: function() {
    return {
      value: 86,
      show: false,
      account: "",
      password: "",
      password2: ""
    };
  },
  mounted: function() {
    if (window.localStorage.getItem("quhao")) {
      this.value = window.localStorage.getItem("quhao");
    }
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    async registerReset() {
      var that = this;
      const { account, password, password2 } = that;
      try {
        await that
          .$validator({
            account: [required(required.message("手机号码"))],
            password: [
              required(required.message("密码")),
              alpha_num(alpha_num.message("密码"))
            ],
            password2: [required(required.message("密码"))]
          })
          .validate({ account, password, password2 });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      if (password != password2) {
        that.$dialog.message("两次密码不一致");
        return;
      }
      this.show = true;
      registerReset({
        area: this.value,
        mobile: that.value + that.account,
        password: that.password
      })
        .then(res => {
          this.show = false;
          that.$dialog.success(res.msg).then(() => {
            that.$router.push({ name: "Login" });
          });
        })
        .catch(res => {
          this.show = false;
          this.$dialog.error(res.response.data.msg);
        });
    }
  }
};
</script>
<style scoped lang="less">
.biaoti {
  /* text-align: center; */
  font-size: 25px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img {
    width: 80px;
    height: 80px;
  }
}
.register_submit {
  width: 100%;
  margin: 0 auto;
  height: 45px;
  background: var(--bg-color);
  border-radius: 30px;
  margin-top: 40px;
  text-align: center;
  line-height: 40px;
  color: #ffffff;
  border: 0px solid;
  font-size: 15px;
  font-weight: bold;
}
.register_block {
  padding: 0 40px;
  margin-top: 20px;
}
.register_block_list {
  width: 100%;
  height: 50px;
  padding: 0 0px;
  /* background: #f1f1f3; */
  /* border-radius: 5px; */
  display: flex;
  align-items: center;
  font-size: 14px;

  border-bottom: 1px solid #eee;
}
/deep/ .van-nav-bar .van-icon {
  color: #333;
}
.register_block_list input {
  line-height: 50px;
  height: 50px;
  width: 100%;
  font-size: 15px;
}
.register_tit {
  display: flex;
  align-items: center;
  position: relative;
  justify-content: center;
  padding: 5px;
}
.register_tit img {
  width: 30px;
  height: 30px;
  position: absolute;
  left: 15px;
}
.register_tit p {
  text-align: center;
  text-align: center;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
  line-height: 35px;
}
/* 清除浮动*/
.am-fl {
  float: left;
}
.am-fr {
  float: right;
}
.am-cf:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.am-cf {
  zoom: 1;
}
/deep/ .flag-list-box {
  background: #fff;
}
/deep/ .flag {
  display: none !important;
}
/deep/ .country-name {
  display: none;
}
/deep/ .intl-tel-input-container {
  padding-left: 0 !important;
  border-right: 1px solid #eee !important;
  flex-shrink: 0;
}
/deep/ .area-codeNum {
  display: inline-block !important;
  padding: 0 2px 0 0 !important;
  font-size: 15px;
}
</style>
